export default __webpack_public_path__ + "static/media/newpay.7ca616a4.webp";